/**
 * RYC feature flag key-value definitions.
 *
 * Pure constants — no imports. Safe to import from anywhere without
 * risk of circular dependencies.
 *
 * These are spread into the global FEATURE_FLAGS object in app-constants.js.
 *
 * @see app-constants.js — spreads RYC_FEATURE_FLAGS into FEATURE_FLAGS
 */
export const RYC_FEATURE_FLAGS = {
  ENABLE_RYC: "enableRYC",
  ENABLE_RYC_METRICS: "enableRYCMetrics",
  ENABLE_RYC_ALERT_VR: "enableRYCAlertVR",
  ENABLE_RYC_ALERT_MISSING_CHECK_IN: "enableRYCAlertMissingCheckIn",
  ENABLE_RYC_ALERT_SAFETY: "enableRYCAlertSafety",
  ENABLE_RYC_EQUIPMENT_FILTER: "enableRYCEquipmentFilter",
  ENABLE_RYC_NOTES_EDIT: "enableRYCNotesEdit",
  ENABLE_RYC_CONTENT_TAGS: "enableRYCContentTags",
  ENABLE_RYC_OPERATIONAL_ACTIVITY_ROW: "enableRYCOperationalActivityRow",
  ENABLE_AUTOMATED_DOCKFLOW_CANCEL_MOVE_WARNING: "enableAutomatedDockFlowCancelMoveWarning",
  ENABLE_YARD_ADD_REMOVE_VEHICLE: "enableYardAddRemoveVehicle",
  ENABLE_RYC_BLUE_FLAG: "enableRYCBlueFlag",
  ENABLE_MANUAL_PRIORITY_INDICATOR: "enableManualPriorityIndicator",
  ENABLE_RYC_LINKED_VEHICLES: "enableRYCLinkedVehicles",
  ENABLE_YARD_AUDIT_MOVE: "enableYardAuditMove",
  ENABLE_YARD_EMERGENCY_CHECKOUT: "enableYardEmergencyCheckout",
  ENABLE_YARD_EMERGENCY_STATUS_OVERRIDE: "enableYardEmergencyStatusOverride",
} as const;
